<template>
  <div class="form-group uk-margin">
    <label
      v-if="label"
      class="uk-form-label"
      :class="{ 'uk-text-danger': this.isInvalid }"
      @click.prevent="onFocus"
    >
      <slot name="label">{{label}} <span v-if="required" style="color: red;">*</span></slot>
    </label>
    <div class="uk-form-controls">
      <slot />
      <validation-hint :errors="errors" />
      <slot name="hints" />
    </div>
  </div>
</template>

<script>
import ValidationHint from '@/components/ValidationHint';

export default {
  name: 'form-group',
  components: {
    ValidationHint,
  },
  props: {
    label: [Boolean, String],
    required: Boolean,
    errors: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isInvalid() {
      return this.errors && this.errors.length > 0;
    },
    isValid() {
      return !this.isInvalid;
    },
  },
  methods: {
    onFocus() {
      this.$emit('focus');
    },
  },
};
</script>



// WEBPACK FOOTER //
// FormGroup.vue?083e3a58